import { Config as VegaLiteConfig } from 'vega-lite';
import { Spec, View } from 'vega';
import { Config } from 'vega-embed';
import { saveAs } from 'file-saver';

export const baseConfig = (): Config => ({
  axis: { labelFont: 'Manrope', titleFont: 'Manrope' },
  legend: { labelFont: 'Manrope', titleFont: 'Manrope' },
  mark: { font: 'Manrope' },
  title: {
    font: 'Manrope',
    subtitleFont: 'Manrope',
    fontSize: 30,
    color: '#1c2026',
    // fontWeight: 700
    dy: -18,
    frame: 'group',
    anchor: 'start',
    fontWeight: 700,
    // anchor: 'start'
  },
});

export const liteBaseConfig = (): VegaLiteConfig => ({
  autosize: 'fit',
  font: 'Manrope',
  title: { fontSize: 30, color: '#1c2026', fontWeight: 600, dy: -18, frame: 'group', anchor: 'start' },
  axis: {
    labelFont: 'Manrope',
    gridColor: '#f8efe6',
    gridWidth: 0,
    domain: false,
    tickColor: '#F1E4D6',
    labelColor: '#82756c',
    domainColor: '#e6ded5',
    tickSize: 6,
    tickCount: 6,
    titlePadding: 10,
    labelPadding: 5,
    titleFontWeight: 800,
    titleColor: '#82756c',
    titleFontSize: 12,
  },
  padding: 10,
  view: { fill: 'none', stroke: 'none' },
  background: 'none',
});

export const baseActions = {
  export: true,
  source: false,
  compiled: false,
  editor: false,
};

export const categoricalColors = ['#636CE9', '#E97063', '#327693', '#F8AE7C', '#973764', '#F1CAF1', '#8BDBF4'];

export type LegendOrientation = 'top' | 'bottom' | 'right' | 'left' | 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left';

export interface ISharedVegaProps {
  showExport?: boolean;
  autofit?: boolean;
  exportTitle?: string;
  exportFileName?: string;
}
